import { ReactNode, createContext, useContext } from "react";
import { ErrorBoundary } from "react-error-boundary";

import { CriticalError } from "checkout-experience/layouts/critical-error";
import { ExperienceType } from "checkout-query-client/api/types";
import { CheckoutSession } from "checkout-query-client/hooks/use-checkout-session";

import {
  GetMerchantSettingsResponse_MerchantSettings,
  PlainMessage,
} from "frontend-client";

type ChexContextWrapperProps = {
  children: ReactNode;
  value: ChexContextType;
};

export type ChexContextType = {
  merchantSettings:
    | PlainMessage<GetMerchantSettingsResponse_MerchantSettings>
    | undefined;
  /**
   * @deprecated get this from the useCheckoutSession
   */
  checkoutSession: CheckoutSession | undefined;
  controlledSubmit?: boolean;
  isCheckoutSessionLoading?: boolean;
  experienceType?: ExperienceType;
  checkoutSessionToken?: string;
  apiHost?: string;
  version?: string;
  googlePayEnv?: string;
  isDemo?: boolean;
  pazeSDK?: string;
  deviceFingerprintSDK?: string;
  target?: string;
  iframePayDomain?: string;
};

export const ChexContext = createContext<ChexContextType>({
  merchantSettings: undefined,
  checkoutSession: undefined,
});

export const ChexContextWrapper = ({
  children,
  value,
}: ChexContextWrapperProps) => {
  return (
    <ErrorBoundary FallbackComponent={CriticalError}>
      <ChexContext.Provider value={value}>{children}</ChexContext.Provider>
    </ErrorBoundary>
  );
};

export const useChexContext = () => {
  return useContext(ChexContext);
};
